import { render, staticRenderFns } from "./LookupByIDList.vue?vue&type=template&id=42f88bc0&"
import script from "./LookupByIDList.vue?vue&type=script&lang=js&"
export * from "./LookupByIDList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports